<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? "Edit Account" : "Add Account" }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="constrained-content">
    <!-- Account Header Section -->
    <div class="account-header-section">
      <ion-card class="account-header-card">
        <ion-card-content>
          <div class="account-header-content">
            <div class="account-icon-container">
              <div (click)="uploadIcon()" class="account-icon-upload">
                <ion-icon
                  name="business-outline"
                  [ngClass]="{ hide: !!imageUrl }"
                ></ion-icon>
                <div
                  *ngIf="imageUrl"
                  class="account-icon-image"
                  [style.background-image]="'url(' + imageUrl + ')'"
                ></div>
                <div class="upload-overlay">
                  <ion-icon name="camera-outline"></ion-icon>
                </div>
              </div>
            </div>
            <div class="account-name-section">
              <ion-label class="section-label">
                Account Name
                <ion-text color="danger" *ngIf="!id">(Required)</ion-text>
              </ion-label>
              <ion-input
                #nameInput
                placeholder="Enter account name"
                [(ngModel)]="name"
                class="account-name-input"
              >
              </ion-input>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Email Domains Section -->
    <div class="form-section">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="mail-outline" class="section-icon"></ion-icon>
            Email Domains
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field">
            <ion-label class="field-label">
              Associated email domains
              <span class="field-description"
                >Add domains to automatically associate emails from these
                domains with this account</span
              >
            </ion-label>

            <div class="domains-container">
              <div *ngIf="emailsAndDomains?.length" class="domains-list">
                <ion-chip
                  outline
                  color="dark"
                  *ngFor="let domain of emailsAndDomains; let i = index"
                  (click)="deleteDomain(i)"
                  class="domain-chip"
                >
                  <ion-icon name="globe-outline"></ion-icon>
                  <ion-label>{{ domain }}</ion-label>
                  <ion-icon name="close" class="remove-icon"></ion-icon>
                </ion-chip>
              </div>

              <div class="add-domain-input">
                <ion-input
                  placeholder="Add domain (e.g. 'company.com') and hit enter"
                  [(ngModel)]="emailDomainToAdd"
                  (keyup.enter)="addDomain()"
                  class="domain-input"
                ></ion-input>
              </div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Slack Integration Section -->
    <div class="form-section">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="logo-slack" class="section-icon"></ion-icon>
            Slack Integration
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field">
            <ion-label class="field-label">
              Associated Slack channels
              <span class="field-description"
                >Link Slack channels to automatically associate messages with
                this account</span
              >
            </ion-label>

            <div *ngIf="slackChannels?.length" class="channels-list">
              <ion-chip
                outline
                color="dark"
                *ngFor="let channel of slackChannels; let i = index"
                (click)="removeChannel(i)"
                class="channel-chip"
              >
                <ion-icon name="logo-slack"></ion-icon>
                <ion-label>#{{ channel.name }}</ion-label>
                <ion-icon name="close" class="remove-icon"></ion-icon>
              </ion-chip>
            </div>
          </div>
          <ion-button
            (click)="openChannelSelector()"
            fill="clear"
            color="primary"
          >
            <ion-icon name="add-outline" slot="start"></ion-icon>
            Add Slack channel
          </ion-button>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Hidden because people don't yet know what slack teams are -->
    <!-- <div class="separator">
        <div class="input-label-container">
          <ion-label class="input-label"> Slack teams </ion-label>
        </div>

        <ion-card class="no-margin">
          <ion-list lines="none" class="no-padding">
            <ion-item *ngIf="slackTeams?.length">
              <ion-label text-wrap>
                <ion-chip outline color="dark" *ngFor="let team of slackTeams; let i = index" (click)="removeTeam(i)">
                  <ion-icon name="people-circle-outline"></ion-icon>
                  <ion-label>{{ team.name }}</ion-label>
                </ion-chip>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-button (click)="openTeamSelector()" fill="clear">Add Slack team</ion-button>
            </ion-item>
          </ion-list>
        </ion-card>
      </div> -->

    <!-- CRM Integration Section -->
    <div class="form-section" *ngIf="id && connectedCrm">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="link-outline" class="section-icon"></ion-icon>
            {{ connectedCrm }} Integration
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field">
            <ion-label class="field-label" *ngIf="!externalCrmMetadata?.id">
              Link to {{ connectedCrm }} account
              <span class="field-description"
                >Connect this account to a record in {{ connectedCrm }} to sync
                data bidirectionally</span
              >
            </ion-label>

            <div *ngIf="externalCrmMetadata?.id">
              <ion-button
                [href]="externalCrmMetadata.url"
                target="_blank"
                fill="outline"
                color="primary"
              >
                <ion-icon name="open-outline" slot="start"></ion-icon>
                Open in {{ connectedCrm }}
              </ion-button>
              <ion-button
                (click)="linkCrm()"
                fill="clear"
                color="medium"
                size="small"
              >
                Change link
              </ion-button>
            </div>

            <div *ngIf="!externalCrmMetadata?.id">
              <ion-button (click)="linkCrm()" fill="outline" color="primary">
                <ion-icon name="link-outline" slot="start"></ion-icon>
                Link to {{ connectedCrm }} account
              </ion-button>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Support Team Section -->
    <div class="form-section">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="people-outline" class="section-icon"></ion-icon>
            Support Team
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field-group">
            <div class="form-field">
              <div class="flexed">
                <div class="flex-grow-1">
                  <ion-label class="field-label">
                    Primary Support Rep
                  </ion-label>
                  <ion-chip
                    mode="ios"
                    class="select-chip select-outline"
                    [outline]="true"
                    (click)="showAssigneeOptions(true)"
                  >
                    <app-avatar
                      *ngIf="primarySupportAssignee"
                      size="20"
                      [style.height]="'18px'"
                      [style.width]="'18px'"
                      [style.margin]="'0 6px 0 -5px'"
                      [name]="primarySupportAssignee.name"
                      [image]="primarySupportAssignee.photo"
                    >
                    </app-avatar>
                    <ion-label>
                      {{ primarySupportAssignee?.name ?? "None" }}
                      <ion-icon
                        name="chevron-down-outline"
                        class="icon-padded-left button-icon"
                      ></ion-icon>
                    </ion-label>
                  </ion-chip>
                </div>
                <div class="flex-grow-1">
                  <ion-label class="field-label">
                    Secondary Support Rep
                  </ion-label>
                  <ion-chip
                    mode="ios"
                    class="select-chip select-outline"
                    [outline]="true"
                    (click)="showAssigneeOptions(false)"
                  >
                    <app-avatar
                      *ngIf="secondarySupportAssignee"
                      size="20"
                      [style.height]="'18px'"
                      [style.width]="'18px'"
                      [style.margin]="'0 6px 0 -5px'"
                      [name]="secondarySupportAssignee.name"
                      [image]="secondarySupportAssignee.photo"
                    >
                    </app-avatar>
                    <ion-label>
                      {{ secondarySupportAssignee?.name ?? "None" }}
                      <ion-icon
                        name="chevron-down-outline"
                        class="icon-padded-left button-icon"
                      ></ion-icon>
                    </ion-label>
                  </ion-chip>
                </div>
              </div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- SLA Configuration Section -->
    <div class="form-section">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="timer-outline" class="section-icon"></ion-icon>
            SLA Configuration
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field">
            <ion-label class="field-label">
              <span
                >SLA Override
                <ion-icon
                  name="information-circle"
                  class="info-icon"
                  ngxTippy
                  data-tippy-content="Configure custom SLA steps for this account. These will override project and tenant defaults if set."
                ></ion-icon
              ></span>
            </ion-label>
            <ion-select
              [(ngModel)]="enableAccountSLA"
              (change)="onEnableAccountSLAChange()"
              interface="popover"
              class="select-outline"
              mode="ios"
            >
              <ion-select-option [value]="false"
                >Use default SLA</ion-select-option
              >
              <ion-select-option [value]="true"
                >Override default SLA</ion-select-option
              >
            </ion-select>
          </div>

          <div *ngIf="enableAccountSLA" class="sla-steps-container">
            <app-support-steps
              [initialSupportSteps]="supportSteps"
              [disabled]="isLoading"
              [loading]="isLoading"
              (didChange)="onSupportStepsChange($event)"
            >
            </app-support-steps>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Custom Fields Section -->
    <div class="form-section">
      <ion-card class="form-card">
        <ion-card-header>
          <ion-card-title class="section-title">
            <ion-icon name="list-outline" class="section-icon"></ion-icon>
            Custom Fields
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="form-field">
            <app-response-input
              *ngIf="customFieldValues"
              [responseInputFields]="customFieldValues"
              [showPublicOption]="false"
              layout="list"
            >
            </app-response-input>

            <div *ngIf="authService.isTenantAdmin">
              <ion-button
                fill="clear"
                color="medium"
                size="small"
                (click)="manageCustomFields()"
              >
                <ion-icon name="cog-outline" slot="start"></ion-icon>
                Manage custom fields
              </ion-button>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <div>
    <ion-button
      (click)="submit()"
      [disabled]="isLoading"
      style="margin-right: 8px"
    >
      <span *ngIf="!isLoading">Save</span>
      <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
    </ion-button>
    <ion-button
      (click)="viewInInbox()"
      fill="clear"
      color="dark"
      [disabled]="isLoading"
    >
      <ion-icon name="file-tray-outline"></ion-icon>
      <span class="hidden-sm text-with-left-icon">View conversations</span>
    </ion-button>
  </div>
  <ion-button
    fill="clear"
    color="dark"
    (click)="delete()"
    [disabled]="isLoading"
    *ngIf="id"
    ngxTippy
    data-tippy-content="Delete"
  >
    <ion-icon name="trash-outline"></ion-icon>
  </ion-button>
</ion-footer>

<ion-modal
  [isOpen]="isShowingCustomFieldsModal"
  (willDismiss)="onDismissCustomFieldsModal()"
>
  <ng-template>
    <ion-header>
      <ion-toolbar class="modal-header">
        <div class="modal-title">
          <h3>Manage Custom Attributes</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button
            fill="clear"
            shape="round"
            class="close-button"
            (click)="onDismissCustomFieldsModal()"
          >
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <app-custom-fields
        placeholder="Ex: Plan type"
        [customFields]="customFieldOptions"
        [addCustomFieldButtonLabel]="'Add a custom customer attribute'"
        [showPublicOption]="true"
        [showUserAttributeOption]="false"
      >
      </app-custom-fields>
      <ion-button
        (click)="updateDefaultCustomFields()"
        [disabled]="isSavingCustomFields"
        class="margin-right-10"
      >
        Save
        <ion-spinner
          name="crescent"
          class="margin-left-5"
          *ngIf="isSavingCustomFields"
        ></ion-spinner>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
